import axios from 'axios'
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.withCredentials = false;
// axios.defaults.baseURL = 'http://localhost:13001';
// axios.defaults.baseURL = 'https://server.roadfly.net';
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:13001' : 'https://server.roadfly.net';
//------------------------------------------
import store from '@/middlewares/store';
//------------------------------------------
import router from "@/middlewares/router";
//------------------------------------------
async function POST(path, data={}, multipart=false){
    try{
        var res = await axios({
            method: 'POST', url: path,   data: data,
            headers: { 
                'Authorization': store.state.token,
                'Content-Type': multipart ? 'multipart/form-data' : 'application/json'
            }
        });
        return (res.status == 200) ? res.data : null;
    }
    catch(err){
        // console.log(err);
        if(err.code == 'ERR_NETWORK'){
            return { 'state': 'Cant connect to server'};
        }
        if(err.response && err.response.status == 401){
            store.dispatch('clearAll');
            router.replace('/login');    
            return { 'state': err.response.data};
        }
        if(err.response && err.response.status == 403){
            store.dispatch('clearAll');
            router.replace('/login');    
            return { 'state': err.response.data};
        }
        if(err.response && err.response.status == 429){
            return { 'state': 'Too Many Requests, wait a minute'};
        }
        if(err.code == 'ERR_BAD_REQUEST'){
            return { 'state': 'Bad Request'};
        }
        console.log(err)
        return { 'state': "Failed" }
    }
}
//------------------------------------------
async function GET(path, params={}, responseType='json'){
    try{
        var res = await axios({
            method: 'GET', url: path,   params: params,
            headers: { 
                'Authorization': store.state.token,
                'Content-Type': 'application/json'
            },
            responseType: responseType,
        });
        if(!res || res.status != 200) return null;

        if(responseType == 'json'){
            return res.data;
        }
        var fileName = "file.xlsx";
        // var matches = (res.headers["content-disposition"] || '').match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        var matches = (res.headers["content-disposition"] || '').match(/filename\*?=(?:utf-8'')?([^;]+)/i);
        if (matches != null && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ""));
        }
        return {
            fileName: fileName,
            blob: new Blob([res.data], { type: res.headers["content-type"] }),
        };
    }
    catch(err){
        console.log(err);
        if(err.code == 'ERR_NETWORK'){
            return { 'state': 'Cant connect to server'};
        }
        if(err.response && err.response.status == 401){
            store.dispatch('clearAll');
            router.replace('/login');    
            return { 'state': err.response.data};
        }
        if(err.response && err.response.status == 403){
            store.dispatch('clearAll');
            router.replace('/login');    
            return { 'state': err.response.data};
        }
        if(err.response && err.response.status == 429){
            return { 'state': 'Too Many Requests, wait a minute'};
        }
        if(err.code == 'ERR_BAD_REQUEST'){
            return { 'state': 'Bad Request'};
        }
        console.log(err)
        return { 'state': "Failed" }
    }
}
export default {
    //------------------------------------------
    baseUrl:                 axios.defaults.baseURL,
    //------------------------------------------
    login:                  async (data) => await POST('login', data),
    logout:                 async (data) => await POST('logout', data),
    getProfile:             async (data) => await GET('getProfile', data),
    saveProfile:            async (data) => await POST('saveProfile', data),
    savePass:               async (data) => await POST('savePass', data),
    //----------------------------------------------------
    getTweaks:              async (data) => await GET('getTweaks', data),
    setTweaks:              async (data) => await POST('setTweaks', data),
    //----------------------------------------------------
    getUsers:               async (data) => await GET('user/getUsers', data),
    addUser:                async (data) => await POST('user/addUser', data),
    editUser:               async (data) => await POST('user/editUser', data),
    delUser:                async (data) => await POST('user/delUser', data),
    logoutUser:             async (data) => await POST('user/logoutUser', data),
    enableUser:             async (data) => await POST('user/enableUser', data),
    disableUser:            async (data) => await POST('user/disableUser', data),
    getPriviledge:          async (data) => await GET('user/getPriviledge', data),
    savePriviledge:         async (data) => await POST('user/savePriviledge', data),
    loadLogs:               async (data) => await GET('user/getLogs', data),
    loadUsersAbstract:      async (data) => await GET('user/getUsersAbstract', data),
    //----------------------------------------------------
    getBranches:            async (data) => await GET('branch/getBranches', data),
    addBranch:              async (data) => await POST('branch/addBranch', data),
    editBranch:             async (data) => await POST('branch/editBranch', data),
    delBranch:              async (data) => await POST('branch/delBranch', data),
    //----------------------------------------------------
    getExpenses:            async (data) => await GET('expenses/getExpenses', data),
    addExpense:             async (data) => await POST('expenses/addExpense', data),
    editExpense:            async (data) => await POST('expenses/editExpense', data),
    delExpense:             async (data) => await POST('expenses/delExpense', data),
    //----------------------------------------------------
    getcustomers:           async (data) => await GET('customer/getcustomers', data),
    addCustomer:            async (data) => await POST('customer/addCustomer', data),
    editCustomer:           async (data) => await POST('customer/editCustomer', data),
    delCustomer:            async (data) => await POST('customer/delCustomer', data),
    customerDeposit:        async (data) => await POST('customer/deposit', data),
    customerWithdrawl:      async (data) => await POST('customer/withdrawl', data),
    customerStatement:      async (data) => await GET('customer/statemenet', data),
    //----------------------------------------------------
    getBrands:              async (data) => await GET('tires/getBrands', data),
    addBrand:               async (data) => await POST('tires/addBrand', data),
    editBrand:              async (data) => await POST('tires/editBrand', data),
    delBrand:               async (data) => await POST('tires/delBrand', data),
    //----------------------------------------------------
    getSizes:               async (data) => await GET('tires/getSizes', data),
    addSize:                async (data) => await POST('tires/addSize', data),
    editSize:               async (data) => await POST('tires/editSize', data),
    delSize:                async (data) => await POST('tires/delSize', data),
    //----------------------------------------------------
    getPatterns:            async (data) => await GET('tires/getPatterns', data),
    addPattern:             async (data) => await POST('tires/addPattern', data),
    editPattern:            async (data) => await POST('tires/editPattern', data),
    delPattern:             async (data) => await POST('tires/delPattern', data),
    //----------------------------------------------------
    getSpecs:               async (data) => await GET('tires/getSpecs', data),
    getTires:               async (data, type='json') => await GET('tires/getTires', data, type),
    addTire:                async (data) => await POST('tires/addTire', data),
    editTire:               async (data) => await POST('tires/editTire', data),
    delTire:                async (data) => await POST('tires/delTire', data),
    //----------------------------------------------------
    getPrices:              async (data) => await GET('tires/getPrices', data),
    savePrices:             async (data) => await POST('tires/savePrices', data),
    //----------------------------------------------------
    getStocks:              async (data, type='json') => await GET('stock/getStocks', data, type),
    getStockDetails:        async (data) => await GET('stock/stockDetails', data),
    //----------------------------------------------------
    supply:                 async (data) => await POST('stock/supply', data),
    getSupplyLog:           async (data) => await GET('stock/supplyLog', data),
    //----------------------------------------------------
    transfer:               async (data) => await POST('stock/transfer', data),
    getTransferOrders:      async (data) => await GET('stock/getTransferOrders', data),
    getTransferDetails:     async (data) => await GET('stock/getTransferDetails', data),
    getTranferReceipt:      async (data) => await GET('stock/getTranferReceipt', data),
    acceptTransfer:         async (data) => await POST('stock/acceptTransfer', data),
    rejectTransfer:         async (data) => await POST('stock/rejectTransfer', data),
    getTransferLog:         async (data) => await GET('stock/transferLog', data),
    //----------------------------------------------------
    return:                 async (data) => await POST('stock/return', data),
    getReturnLog:           async (data) => await GET('stock/returnLog', data),
    //----------------------------------------------------
    changeStock:            async (data) => await POST('stock/change', data),
    fixStock:               async (data) => await POST('stock/fix-stock', data),
    //----------------------------------------------------
    getOthersAbstract:      async (data) => await GET('others/getOthersAbstract', data),
    getOthers:              async (data) => await GET('others/getOthers', data),
    addOther:               async (data) => await POST('others/addOther', data),
    editOther:              async (data) => await POST('others/editOther', data),
    delOther:               async (data) => await POST('others/delOther', data),
    //----------------------------------------------------
    getInvoices:            async (data, type) => await GET('sales/getInvoices', data, type),
    getInvoice:             async (data) => await GET('sales/getInvoice', data),
    delInvoice:             async (data) => await POST('sales/delInvoice', data),
    payPart:                async (data) => await POST('sales/payPart', data),
    //----------------------------------------------------
    getReturns:             async (data) => await GET('sales/getReturns', data),
    getReturnReceipt:       async (data) => await GET('sales/getReturnReceipt', data),
    returnInvoice:          async (data) => await POST('sales/returnInvoice', data),
    //----------------------------------------------------
    getTiresAbstract:       async (data) => await GET('tires/getTiresAbstract', data),
    getBranchesAbstract:    async (data) => await GET('branch/getBranchesAbstract', data),
    getBranchesAbstractV2:  async (data) => await GET('branch/getBranchesAbstractV2', data),

    getStock:               async (data) => await GET('cart/getStock', data),
    checkStock:             async (data) => await GET('cart/checkStock', data),
    getCart:                async (data) => await GET('cart/getCart', data),
    getCustomer:            async (data) => await GET('customer/getCustomer', data),
    saveCartItems:          async (data) => await POST('cart/saveItems', data),
    saveCartCustomer:       async (data) => await POST('cart/saveCustomer', data),
    clearCart:              async (data) => await POST('cart/clearCart', data),
    checkout:               async (data) => await POST('cart/checkout', data),
    // searchCustomers:        async (data) => await GET('customer/searchCustomers', data),
    //---------------------------------------------------- Statistics
    getMostSoldByQuantity:  async (data) => await GET('stats/mostSoldByQuantity', data),
    getMostSoldByValue:     async (data) => await GET('stats/mostSoldByValue', data),
    getExpensesStats:       async (data) => await GET('stats/getExpensesStats', data),
    getSalesStats:          async (data) => await GET('stats/get-sales-stats', data),
    getRevenueStats:        async (data) => await GET('stats/get-revenue-stats', data),

    //----------------------------------------------------
}